import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { NativeSelect } from '@vitessce/styles';
import { useStyles } from './styles.js';
export default function OptionSelect(props) {
    const { classes: classesProp = {} } = props;
    const { classes } = useStyles();
    return (_jsx(NativeSelect, { disableUnderline: true, ...props, classes: {
            root: classes.optionSelectRoot,
            ...classesProp,
        }, "aria-label": "Select an option" }));
}
//# sourceMappingURL=OptionSelect.js.map